export const setAuthToken = (token) => {
  return localStorage.setItem("token", token);
};

export const getAuthToken = () => {
  const token = localStorage.getItem("token");
  // a missing token can get stringified into localStorage as "undefined"/"null",
  // which would otherwise be sent as a valid-looking bearer value
  if (!token || token === "undefined" || token === "null") return "";
  return token;
};

export const setAuthUser = (user) => {
  setAuthToken(user.token);
  return localStorage.setItem("user", JSON.stringify(user));
};

export const getAuthUser = () => {
  return JSON.parse(localStorage.getItem("user"));
};

export const removeAuthToken = () => {
  return localStorage.removeItem("token");
};

export const removeAuthUser = () => {
  removeAuthToken();
  return localStorage.removeItem("user");
};

export const setLoggedUser = (user) => {
  localStorage.setItem("profile", JSON.stringify(user));
  return true;
};
